import React, { useEffect, useState } from 'react';
import { TrendingUpIcon, TrendingDownIcon, ArrowRightIcon } from 'lucide-react';
interface MetalPrice {
  name: string;
  price: number;
  change: number;
  changePercentage: number;
}
export const MetalPriceUpdates: React.FC = () => {
  const [metalPrices, setMetalPrices] = useState<MetalPrice[]>([{
    name: 'Gold',
    price: 2084.75,
    change: 12.5,
    changePercentage: 0.6
  }, {
    name: 'Silver',
    price: 24.32,
    change: 0.18,
    changePercentage: 0.75
  }, {
    name: 'Platinum',
    price: 1045.2,
    change: -3.4,
    changePercentage: -0.32
  }, {
    name: 'Palladium',
    price: 1680.5,
    change: -5.25,
    changePercentage: -0.31
  }]);
  // Simulate price updates
  useEffect(() => {
    const interval = setInterval(() => {
      setMetalPrices(prices => prices.map(metal => {
        const randomChange = (Math.random() - 0.48) * 2;
        const newPrice = +(metal.price + randomChange).toFixed(2);
        return {
          ...metal,
          price: newPrice,
          change: +(newPrice - metal.price + metal.change).toFixed(2),
          changePercentage: +(metal.change / metal.price * 100).toFixed(2)
        };
      }));
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-12 bg-gray-50 dark:bg-gray-800" data-id="element-247">
      <div className="container mx-auto px-4" data-id="element-248">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-249">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-4 md:mb-0" data-id="element-250">
            Precious Metals Market Update
          </h2>
          <div className="flex items-center text-sm text-gray-500 dark:text-gray-400" data-id="element-251">
            <span data-id="element-252">Last updated: {new Date().toLocaleTimeString()}</span>
            <div className="ml-2 h-2 w-2 rounded-full bg-green-500 animate-pulse" data-id="element-253"></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-254">
          {metalPrices.map(metal => <div key={metal.name} className="bg-white dark:bg-gray-900 rounded-lg shadow-md p-6" data-id="element-255">
              <div className="flex justify-between items-start mb-4" data-id="element-256">
                <div data-id="element-257">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-258">
                    {metal.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-259">
                    Spot Price (USD/oz)
                  </p>
                </div>
                {metal.change >= 0 ? <TrendingUpIcon className="text-green-500" size={20} data-id="element-260" /> : <TrendingDownIcon className="text-red-500" size={20} data-id="element-261" />}
              </div>
              <div className="mb-2" data-id="element-262">
                <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-263">
                  $
                  {metal.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
                </span>
              </div>
              <div className="flex items-center" data-id="element-264">
                <span className={`text-sm font-medium ${metal.change >= 0 ? 'text-green-500' : 'text-red-500'}`} data-id="element-265">
                  {metal.change >= 0 ? '+' : ''}$
                  {Math.abs(metal.change).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
                </span>
                <span className={`ml-2 text-sm font-medium ${metal.change >= 0 ? 'text-green-500' : 'text-red-500'}`} data-id="element-266">
                  ({metal.change >= 0 ? '+' : ''}
                  {metal.changePercentage}%)
                </span>
              </div>
            </div>)}
        </div>
        <div className="mt-8 text-center" data-id="element-267">
          <a href="#" className="inline-flex items-center text-yellow-500 hover:text-yellow-600 font-medium" data-id="element-268">
            View detailed market analysis
            <ArrowRightIcon size={16} className="ml-1" data-id="element-269" />
          </a>
        </div>
      </div>
    </section>;
};